import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import Input from "../../../Input/Input";
import { SEARCH_QUERY } from "../../../../../Utils/AllPagesQuriesAndMutations";
import "./CityState.scss";
import { ZonesData } from "./CityState.config";
const SearchCitiesQuery = gql`
  query SearchCities($keyword: String, $limit: BigInt) {
    searchCities(keyword: $keyword, Limit: $limit) {
      _id
      Unique_Id
      name
      Latitude
      Longitude
      State
      Search_Value
    }
  }
`;

const SearchStatesQuery = gql`
  query SearchStates($keyword: String!, $limit: BigInt) {
    searchStates(keyword: $keyword, Limit: $limit) {
      _id
      Unique_Id
      name
      code
      Country
      value
      label
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

const CityState = ({ options, title, selectedData, setSelectedData, googleSearchValue, setGoogleSearch, formkey }) => {
  const [CityOrState, setCityOrState] = useState(options.includes("Place Search") ? "Place" : "State");
  const [searchInput, setSearchInput] = useState("");
  const [selectAllFromStates, setSelectAllFromStates] = useState(false);
  const [selectedZone, setSelectedZones] = useState({});
  const {
    loading,
    error,
    data: CityStateData,
    refetch: refetchCityState,
  } = useQuery(CityOrState === "City" ? SearchCitiesQuery : SearchStatesQuery, {
    variables: { keyword: searchInput },
    fetchPolicy: "network-only",
  });

  const handleSearchInput = (e) => {
    const input = e.target.value;
    setSearchInput(input);
    refetchCityState({ keyword: input });
  };

  const handleCheckboxChange = (cityId, cityType) => {
    console.log(CityStateData);
    let updatedCities;
    if (cityType === "fromCity") {
      const cityNameOrStateName =
        CityOrState === "City"
          ? CityStateData?.searchCities.find((city) => city._id === cityId)?.name
          : CityStateData?.searchStates.find((state) => state._id === cityId)?.name;
      if (selectedData.some((city) => city.Location === cityNameOrStateName)) {
        updatedCities = selectedData.filter((city) => city.Location !== cityNameOrStateName);
      } else {
        updatedCities = [...selectedData, { Location: cityNameOrStateName, Type: CityOrState }];
      }

      setSelectedData(updatedCities);
    } else if (cityType === "toCity") {
      const cityNameOrStateName =
        CityOrState === "City"
          ? CityStateData?.searchCities.find((city) => city._id === cityId)
          : CityStateData?.searchStates.find((state) => state._id === cityId);
      if (selectedData.some((city) => city.Location === cityNameOrStateName?.name)) {
        updatedCities = selectedData.filter((city) => city.Location !== cityNameOrStateName?.name);
      } else {
        updatedCities = [
          ...selectedData,
          {
            Location: cityNameOrStateName?.name, //Unloading_Name
            Latitude: cityNameOrStateName?.Latitude,
            Longitude: cityNameOrStateName?.Longitude,
            State: cityNameOrStateName?.State,
            Type: CityOrState === "Zone" ? "State" : CityOrState,
          },
        ];
      }

      setSelectedData(updatedCities);
    }
  };

  const handleSelectAll = () => {
    // Toggle the state of "Select all states" checkbox
    setSelectAllFromStates(!selectAllFromStates);
    // If "Select all states" is checked, select all states in the list
    if (!selectAllFromStates) {
      const allStateIds = CityStateData?.searchStates.map((state) => ({
        Location: state.name,
        Type: CityOrState,
      }));
      setSelectedData(allStateIds);
    } else {
      setSelectedData([]);
    }
  };
  const isZoneSelected = (zone) => {
    return zone.states.every((state) => selectedData.some((item) => item.Location === state.name));
  };
  const SelectWholeZone = (zone) => {
    const currentData = selectedData || [];

    // Check if all states in the zone are already selected
    const allSelected = zone.states.every((state) => currentData.some((item) => item.Location === state.name));

    let updatedData;
    if (allSelected) {
      // If all states are selected, filter them out to unselect the zone
      updatedData = currentData.filter((item) => !zone.states.some((state) => state.name === item.Location));
    } else {
      // Filter out any already selected states to avoid duplicates
      const newStates = zone.states
        .filter((state) => !currentData.some((currentItem) => currentItem.Location === state.name))
        .map((item) => ({
          Location: item.name,
          Type: "State",
        }));

      // Combine current data with new, non-duplicate data
      updatedData = currentData.concat(newStates);
    }

    // Update the state with the modified data
    setSelectedData(updatedData);
  };

  console.log(selectedData, "selectedDataselectedData");
  return (
    <div className="firstcontainer">
      <div>
        {/* <label className="headings">{title + " " + CityOrState}</label> */}
        <p className="headings" style={{ margin: "2px" }}>
          {title + " " + CityOrState}
        </p>
        {options?.includes("State") && (
          <label>
            <input
              type="radio"
              value="State"
              checked={CityOrState === "State"}
              onChange={() => {
                setCityOrState("State");
              }}
            />
            State
          </label>
        )}
        {options?.includes("City") && (
          <label>
            <input
              type="radio"
              value="City"
              checked={CityOrState === "City"}
              onChange={() => {
                setCityOrState("City");
              }}
            />
            City
          </label>
        )}
        {options?.includes("Zone") && (
          <label>
            <input
              type="radio"
              value="Zone"
              checked={CityOrState === "Zone"}
              onChange={() => {
                setCityOrState("Zone");
              }}
            />
            Zone
          </label>
        )}
        {options?.includes("Place Search") && (
          <label>
            <input
              type="radio"
              value="State"
              checked={CityOrState === "Place"}
              onChange={() => {
                setCityOrState("Place");
              }}
            />
            Place Search
          </label>
        )}
        {CityOrState !== "Place" && CityOrState !== "Zone" && (
          <div>
            <input
              className="Cityinput"
              type="text"
              // placeholder={searchInputPlaceholder}
              placeholder="Search"
              value={searchInput}
              onChange={handleSearchInput}
            />
          </div>
        )}
        <div>
          {CityOrState === "State" && options?.includes("State") ? (
            <label>
              <input type="checkbox" checked={selectAllFromStates} onChange={handleSelectAll} />
              All states
            </label>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="Cityesdata">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>Error: {error.message}</p>
        ) : CityOrState === "State" ? (
          CityStateData?.searchStates?.map((state) => (
            <div key={state._id}>
              <input
                type="checkbox"
                checked={selectedData?.map((e) => e.Location).includes(state.name)}
                onChange={() => {
                  handleCheckboxChange(
                    state._id,
                    title.includes("From") ? "fromCity" : title.includes("To") ? "toCity" : ""
                  );
                }}
              />
              <label>{state.name}</label>
            </div>
          ))
        ) : CityOrState === "City" ? (
          CityStateData?.searchCities?.map((city) => (
            <div key={city._id}>
              <input
                type="checkbox"
                checked={selectedData?.map((e) => e.Location).includes(city.name)}
                onChange={() =>
                  handleCheckboxChange(
                    city._id,
                    title.includes("From") ? "fromCity" : title.includes("To") ? "toCity" : ""
                  )
                }
              />
              <label>{city.name}</label>
            </div>
          ))
        ) : CityOrState === "Zone" ? (
          ZonesData?.map((zone) => (
            <div key={zone._id}>
              <input type="checkbox" checked={isZoneSelected(zone)} onChange={() => SelectWholeZone(zone)} />
              <label className="ZoneName">{zone.zone}</label>
              {zone?.states?.map((state) => (
                <div key={state._id}>
                  <input
                    type="checkbox"
                    checked={selectedData?.map((e) => e.Location).includes(state.name)}
                    onChange={() =>
                      handleCheckboxChange(
                        state._id,
                        title.includes("From") ? "fromCity" : title.includes("To") ? "toCity" : ""
                      )
                    }
                  />
                  <label>{state.name}</label>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="inpCont">
            <Input
              checked={false}
              InputConfig={""}
              TypeOfPortal={""}
              name={`${title}_Location`}
              disabled={false}
              value={googleSearchValue}
              label={`${title}_Location`}
              className={""}
              type={"GoogleSearch"}
              modalform={true}
              EMTQuery={{ headers: { "X-GraphQL-Server": "secondary" } }}
              handleInputChange={(e) => {
                setGoogleSearch(e.target.value);
              }}
              dropdowndata={SEARCH_QUERY}
              handleBlur={() => {}}
              touched={""}
              error={""}
              max={undefined}
              notSearchable={false}
              Section_Type=""
              JurnalDropdown=""
              transactions=""
              PaymentProcess=""
              formkey={formkey}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CityState;
